export enum LanguagesSystem {
  ENGLISH = 'en',
  UZBEK = 'uz',
  RUSSIAN = 'ru',
  KARAKALPAK = 'kaa',
}
export const DefaultLanguage = LanguagesSystem.UZBEK;

export enum LanguagesOlimpiad {
  Uz = 0, // Uzbek
  Ru = 1, // Rus
  En = 2, // English
  Kaa = 3, // Qoraqalpoq
  Tg = 4, // Tojik
  Kk = 5, // Qozoq
  Ky = 6, // Qirg'iz
  Tk = 7, // Turkman
}
